import React from 'react';
import './Footer.css'
import fb from '../../Assets/Facebook.png'
import linkedin from '../../Assets/LinkedIn.png'
import git from '../../Assets/git.png'

const Footer = () => {
    return (
        <div className="p-3 mt-5 bgglass">
            <hr className="text-center text-white w-75 mx-auto mt-5" />
            <p className="text-white text-center txbg ">All rights reserved © Kamrun Nahar 2021 | Web developer</p>
            <div className="px-5 d-flex justify-content-center txbg ">
                <a  className="mx-3 txbg " target="_blank"   href="https://github.com/iknahar">
                <img src={git} style={{width: "100px"}} className="txbg " alt="" />

                </a>
                <a className="mx-3 txbg " target="_blank" href="https://www.linkedin.com/in/knahar/">
                   
                <img src={linkedin} style={{width: "100px"}}  className="txbg " alt="" />
                </a>
                <a className="mx-3 txbg" target="_blank" href="https://www.facebook.com/iknahar">
                    <img  className="txbg "src={fb} style={{width: "93px"}} alt="" />
                </a>
            </div>
        </div>
    );
};

export default Footer;